(function () {
    var wall = document.getElementById('wall');
    var moreBtn = document.getElementById('wall-more');
    var moreWrap = document.getElementById('wall-more-wrap');
    var endNote = document.getElementById('wall-end');
    var data = document.querySelectorAll('.im8_uk90_protocol-09_container .review-item');
    var REVIEWS = Array.prototype.map.call(data, function (item) {
      return { name: item.getAttribute('data-review-name') || '', text: item.getAttribute('data-review-text') || '' };
    });
    var INITIAL = 10;
    var BATCH = 10;
    var count = 0;
    function card(r) {
      var d = document.createElement('div');
      d.className = 'wall-card';
      var head = document.createElement('div');
      head.className = 'wm-head';
      var av = document.createElement('span');
      av.className = 'wm-avatar';
      av.textContent = 'I\u00B7M\u00B78';
      var nm = document.createElement('b');
      nm.textContent = r.name;
      head.appendChild(av); head.appendChild(nm);
      var body = document.createElement('p');
      body.textContent = r.text;
      d.appendChild(head); d.appendChild(body);
      return d;
    }
    function append(n) {
      for (var i = 0; i < n && count < REVIEWS.length; i++) {
        wall.appendChild(card(REVIEWS[count]));
        count++;
      }
      if (count >= REVIEWS.length) {
        moreWrap.hidden = true;
        endNote.hidden = false;
      }
    }
    moreBtn.addEventListener('click', function () { append(BATCH); });
    append(INITIAL);
  })();

(function () {
    document.querySelectorAll('.im8_uk90_protocol-05_container').forEach(function (section) {
      var grid = section.querySelector('#flavor-grid');
      var planFlavor = section.querySelector('#plan-flavor');
      var mainAtc = section.querySelector('#uk90-main-atc');
      var status = section.querySelector('#uk90-atc-status');
      if (!grid || !mainAtc) return;

      function applySelection(btn, animate) {
        grid.querySelectorAll('.flavor-item').forEach(function (item) {
          var selected = item === btn;
          item.classList.toggle('selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        mainAtc.setAttribute('data-variant-id', btn.getAttribute('data-variant-90'));
        if (status && animate) status.textContent = '';
        if (planFlavor) {
          planFlavor.textContent = btn.getAttribute('data-flavor');
          if (animate) {
            planFlavor.classList.remove('is-updating');
            void planFlavor.offsetWidth;
            planFlavor.classList.add('is-updating');
          }
        }
      }

      function setLoading(trigger, loading) {
        trigger.disabled = loading;
        trigger.setAttribute('aria-busy', loading ? 'true' : 'false');
        trigger.classList.toggle('is-loading', loading);
      }

      async function addSelectedVariant(trigger) {
        var variantId = trigger.getAttribute('data-variant-id');
        var sellingPlan = trigger.getAttribute('data-selling-plan');
        var selected = grid.querySelector('.flavor-item.selected');
        var scrollPosition = { x: window.scrollX, y: window.scrollY };
        if (!variantId || !sellingPlan) return;
        setLoading(trigger, true);
        if (status) status.textContent = 'Adding ' + (selected ? selected.getAttribute('data-flavor') : 'your selection') + ' to cart…';

        try {
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          var sections = cart && typeof cart.getSectionsToRender === 'function'
            ? cart.getSectionsToRender().map(function (item) { return item.id; })
            : [];
          var mainItem = { id: Number(variantId), quantity: 1, selling_plan: Number(sellingPlan) };
          // IM8Cart (global.js): Standard Actions first, guarded Ajax second.
          // Resolves to the /cart/add.js contract; rejections carry `.status`,
          // bot-challenge / timeout errors throw with `.cartBlocked` / AbortError.
          var data;
          try {
            data = await window.IM8Cart.add([mainItem], { sections: sections, context: 'product' });
          } catch (transportError) {
            if (window.IM8CartGuard && transportError && (transportError.cartBlocked || transportError.name === 'AbortError')) {
              window.IM8CartGuard.recoverViaNavigation(mainItem, { returnTo: '/cart' });
              return;
            }
            throw new Error(transportError && transportError.status === 429 ? 'Too many requests. Please wait a moment and try again.' : 'Unable to add this selection.');
          }
          if (!data || data.status) throw new Error((data && (data.description || data.message)) || 'Unable to add this selection.');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && typeof EVENT_TYPE !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'uk90-protocol', productVariantId: variantId, cartData: data, eventType: EVENT_TYPE.add });
          }
          if (cart && typeof cart.renderContents === 'function' && data.sections && Object.keys(data.sections).length) {
            cart.renderContents(data);
            requestAnimationFrame(function () {
              window.scrollTo(scrollPosition.x, scrollPosition.y);
              requestAnimationFrame(function () { window.scrollTo(scrollPosition.x, scrollPosition.y); });
            });
          }
          else { window.location.href = '/cart'; return; }
          if (status) status.textContent = 'Added to cart.';
        } catch (error) {
          console.error('[UK 90-Day Protocol] Add to cart failed:', error);
          if (status) status.textContent = error.message || 'Unable to add this selection. Please try again.';
        } finally {
          setLoading(trigger, false);
        }
      }

      grid.addEventListener('click', function (event) {
        var btn = event.target.closest('.flavor-item');
        if (btn) applySelection(btn, true);
      });
      mainAtc.addEventListener('click', function () { addSelectedVariant(mainAtc); });
      applySelection(grid.querySelector('.flavor-item.selected') || grid.querySelector('.flavor-item'), false);
    });
  })();
  (function () {
    document.querySelectorAll('.im8_uk90_protocol-05_container').forEach(function (section) {
      var main = section.querySelector('#gallery-main');
      var wrap = section.querySelector('#gallery-thumbs');
      var prev = section.querySelector('#thumbs-prev');
      var next = section.querySelector('#thumbs-next');
      if (!main || !wrap || !prev || !next) return;
      prev.addEventListener('click', function () { wrap.scrollBy({ left: -190, behavior: 'smooth' }); });
      next.addEventListener('click', function () { wrap.scrollBy({ left: 190, behavior: 'smooth' }); });
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.g-thumb');
        if (!btn) return;
        var image = btn.querySelector('img');
        if (!image) return;
        main.src = btn.getAttribute('data-full');
        main.alt = image.alt;
        wrap.querySelectorAll('.g-thumb').forEach(function (thumb) { thumb.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  })();
  (function () {
    var bar = document.getElementById('sticky-bar');
    var hero = document.querySelector('section.hero');
    var buy = document.getElementById('buy');
    var last = 0;
    function update() {
      var pastHero = window.scrollY > hero.offsetTop + hero.offsetHeight;
      var b = buy.getBoundingClientRect();
      var buyInView = b.top < window.innerHeight && b.bottom > 0;
      bar.classList.toggle('visible', pastHero && !buyInView);
    }
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - last < 100) return;
      last = now;
      update();
    }, { passive: true });
    update();
  })();
